import React from "react";

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_oklch(0.98_0.02_80),_oklch(1_0_0)_60%)]">
      <div className="relative min-h-screen overflow-hidden">
        <div className="pointer-events-none absolute -left-40 top-16 h-80 w-80 rounded-full bg-[oklch(0.92_0.07_60)] blur-3xl" />
        <div className="pointer-events-none absolute -right-32 bottom-20 h-72 w-72 rounded-full bg-[oklch(0.85_0.12_35)] blur-3xl" />

        <div className="relative z-10 grid min-h-screen lg:grid-cols-[1.1fr_0.9fr]">
          <div className="hidden flex-col justify-between p-12 lg:flex">
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-2xl bg-primary text-primary-foreground shadow-md shadow-primary/30" />
              <div>
                <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Taxio</p>
                <p className="text-2xl font-semibold">Portail Communautes</p>
              </div>
            </div>

            <div className="space-y-6">
              <p className="text-3xl font-semibold leading-tight">
                Acces securise pour gerer vos collectes et vos equipes.
              </p>
              <ul className="space-y-3 text-sm text-muted-foreground">
                <li className="flex items-center gap-3">
                  <span className="h-2 w-2 rounded-full bg-primary" />
                  Suivi en temps reel des paiements et des agents.
                </li>
                <li className="flex items-center gap-3">
                  <span className="h-2 w-2 rounded-full bg-primary" />
                  Administration centralisee des communes.
                </li>
                <li className="flex items-center gap-3">
                  <span className="h-2 w-2 rounded-full bg-primary" />
                  Donnees securisees et historisees.
                </li>
              </ul>
            </div>

            <p className="text-xs text-muted-foreground">
              Besoin d'aide ? Contactez l'equipe support Taxio.
            </p>
          </div>

          <div className="flex min-h-screen items-center justify-center p-6">
            <div className="w-full max-w-md rounded-3xl border border-white/50 bg-white/90 p-8 shadow-2xl shadow-black/10 backdrop-blur">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
